import { FC } from "react";
import { AnalyticsProvider } from "~context/analyticsContext";
import { useCookieConsent } from "~context/cookieConsentContext";
import {
  GoogleAnalyticsScript,
  FlicketGoogleTagManagerScripts,
  HotjarScript,
} from "~features/tracking/analytics/integrations";

export const AnalyticsConsentProvider: FC = ({ children }) => {
  const { isAnalyticsAllowed } = useCookieConsent();

  if (isAnalyticsAllowed) {
    return (
      <AnalyticsProvider>
        <GoogleAnalyticsScript />
        <HotjarScript />
        <FlicketGoogleTagManagerScripts />
        {children}
      </AnalyticsProvider>
    );
  }

  return <>{children}</>;
};
